module.exports = __webpack_public_path__ + "img/district.e5845d67.gif";